import { contextualizeQuestion } from '../models';
export var questionsLayers = [{
  id: 'Question',
  type: 'view',
  action: 'question',
  name: 'question',
  event: true,
  contextualize: function contextualize(_ref) {
    var question = _ref.question;
    return contextualizeQuestion(question);
  }
}, {
  id: 'Answer',
  type: 'view',
  action: 'answer',
  name: 'answer',
  event: true,
  contextualize: function contextualize(_ref2) {
    var answer = _ref2.answer,
      author = _ref2.author;
    return {
      answer: {
        id: answer.id
      },
      author: {
        id: author.id,
        alias: author.alias,
        displayName: author.name,
        type: 'user',
        isAdviser: Boolean(author.adviserAt),
        isProfessional: false
      }
    };
  }
}];